export const fetchBoosterPack = (products) => dispatch => {
  dispatch({
    type: 'FETCH_BOOSTER_PACK',
    payload: products,
  })
 }